import React, { Component } from 'react';
import browserHistory from '../../history';
import axios from 'axios';
import Loader from '../Loader';
import Header from '../authentication/Header';
import Footer from '../authentication/Footer';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: {},
            isLoading: false,
            query: '',
            error: null,
        };
    }

    getQueryParam(name) {
        const params = new URLSearchParams(this.props.location && this.props.location.search);
        return params.get(name) || '';
    }

    getAssetImageUrl(asset) {
        const config = (window.site && window.site.config) || (window.app && window.app.defaultSiteSettings && window.app.defaultSiteSettings.config) || {};
        const sourceCloudFront = config.sourceCloudFront || '';
        const defaultLandscapeImg = config.defaultLandscape || '';
        const autoCompress = '?auto=compress,format&width=300';

        const envoiPortraitPath = asset.destinations && asset.destinations.uploads && asset.destinations.uploads.envoi && asset.destinations.uploads.envoi.envoi_portrait && asset.destinations.uploads.envoi.envoi_portrait.filePath;
        if (sourceCloudFront && envoiPortraitPath) {
            return sourceCloudFront + '/' + envoiPortraitPath.replace(/ /g, '%20') + autoCompress;
        }else if(asset.thumbnail) {
            return asset.thumbnail
        }
        return (asset.portrait_logo_image || defaultLandscapeImg) + autoCompress;
    }

    fetchResults(query) {
        if (!query) {
            this.setState({ groups: {}, isLoading: false, error: null });
            return;
        }

        const siteSettings = window.site || {};
        const appSettings = window.app || {};
        const appStorage = appSettings.storage || {};
        const screeningApiBaseUrl = siteSettings.screeningApiBaseUrl || '';
        const appName = appStorage.getItem('appName') || window.app.appName || '';
        const env = appStorage.getItem('appEnvName') || window.app.appEnvName || '';
        const token = appStorage.getItem('token') || localStorage.getItem('token') || sessionStorage.getItem('token') || '';

        let country = '', region = '', city = '', timezone = '';
        try {
            const locationObj = JSON.parse(localStorage.getItem('loc'));
            if (locationObj && locationObj.headers) {
                const h = locationObj.headers;
                country = (h['cloudfront-viewer-country-name'] && h['cloudfront-viewer-country-name'][0] && h['cloudfront-viewer-country-name'][0].value) || '';
                region = (h['cloudfront-viewer-country-region'] && h['cloudfront-viewer-country-region'][0] && h['cloudfront-viewer-country-region'][0].value) || '';
                city = (h['cloudfront-viewer-city'] && h['cloudfront-viewer-city'][0] && h['cloudfront-viewer-city'][0].value) || '';
                timezone = (h['cloudfront-viewer-time-zone'] && h['cloudfront-viewer-time-zone'][0] && h['cloudfront-viewer-time-zone'][0].value) || '';
            }
        } catch (e) {}
        if (!timezone) timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';

        let url = `${screeningApiBaseUrl}/search?appname=${appName}&env=${env}&type=asset`;
        if (country) url += `&country=${encodeURIComponent(country)}`;
        if (region) url += `&region=${encodeURIComponent(region)}`;
        if (city) url += `&city=${encodeURIComponent(city)}`;
        if (timezone) url += `&timezone=${encodeURIComponent(timezone)}`;
        if (token) url += `&token=${token}`;

        this.setState({ isLoading: true, error: null });

        axios.post(url, { search: query }, { headers: { 'content-type': 'application/json' } })
            .then((response) => {
                const data = response.data.result;
                let groups = {};
                if (data && typeof data === 'object' && !Array.isArray(data)) {
                    // Response is { Films: [...], Movies: [...], Commercials: [...] }
                    Object.keys(data).forEach((key) => {
                        console.log(`Processing group: ${key}`, data[key]);
                        if (Array.isArray(data[key]) && data[key].length > 0 && key !== 'Films') {
                            groups[key] = data[key];
                        }
                    });
                }
                this.setState({ groups, isLoading: false });
            })
            .catch(() => {
                this.setState({ isLoading: false, error: 'Failed to load search results. Please try again.' });
            });
    }

    componentDidMount() {
        const query = this.getQueryParam('q');
        this.setState({ query });
        this.fetchResults(query);
    }

    componentDidUpdate(prevProps) {
        const prevSearch = prevProps.location && prevProps.location.search;
        const currSearch = this.props.location && this.props.location.search;
        if (prevSearch !== currSearch) {
            const query = this.getQueryParam('q');
            this.setState({ query });
            this.fetchResults(query);
        }
    }

    goToAsset(asset) {
        const trailerAssetid = Array.isArray(asset.trailer) && asset.trailer[0] && asset.trailer[0].assetid;
        browserHistory.push({
            pathname: '/asset',
            search: `?assetid=${asset.assetid}&appname=${window.app.appName}`,
            state: { assetType: asset.assetType, trailerAssetid },
        });
    }

    render() {
        const { groups, isLoading, query, error } = this.state;
        const groupKeys = Object.keys(groups);
        const totalCount = groupKeys.reduce((sum, k) => sum + groups[k].length, 0);
        const hasResults = groupKeys.length > 0;

        console.log('Search Results:', groups);
        console.log('Search Error:', error);
        console.log('Search Query:', query);
        console.log('Is Loading:', isLoading);
        console.log('Has Results:', hasResults);
        console.log('Total Count:', totalCount);
        return (
            <React.Fragment>
                {isLoading && <Loader />}
                <div className="recording_page">
                    <Header />
                    <div className="enchannel_wrapper minbody-ht" style={{ minHeight: 'calc(100vh - 180px)' }}>
                      

                       

                        {!isLoading && !error && hasResults && groupKeys.map((groupName) => (
                            <div key={groupName} className="search-group">
                                <h3 className="search-group-title">{groupName}</h3>
                                <div className="row">
                                    {groups[groupName].map((asset, i) => (
                                        <div className="col-12 col-sm-4 col-md-3 col-lg-2" key={asset.assetid || i}>
                                            <div className="channel-card" onClick={() => this.goToAsset(asset)} style={{ cursor: 'pointer' }}>
                                                <div className="channel-thumb">
                                                    {asset.formatedduration && (
                                                        <span className="asset_duration">{asset.formatedduration}</span>
                                                    )}
                                                    <img alt={asset.assetname || 'asset'} src={this.getAssetImageUrl(asset)} />
                                                </div>
                                                <div className="channel-footer">
                                                    <h5>{asset.assetname}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                        {!isLoading && !hasResults && query && (
                            <div className="warning-wrapper empty-result">
                                <img
                                    src="https://envoi-common-resources.imgix.net/screening/images/common-images/no-data-found.jpg"
                                    className="no-data-found"
                                    alt="no results"
                                />
                                <div className="error-text">
                                    <h2 className="text-center">No Results</h2>
                                    <p>No assets found for "{query}"</p>
                                </div>
                            </div>
                        )}
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
        );
    }
}

export default Search;
